import React from 'react';

const HeleneMannaDonationMessage = () => {
	if (new Date().getFullYear() !== 2024) {
		return null;
	}

	return (
		<div style={{ marginTop: '10px' }}>
			Skip the discount and we'll double{' '}
			<a
				href="https://connect.gdx.net/blog/2024/10/supporting-recovery-in-wnc-with-manna-food-bank"
				target="_blank"
				rel="noopener noreferrer"
			>
				our donation to MANNA foodbank
				<span className="fa fa-external-link pl-5" aria-hidden="true"></span>
			</a>
		</div>
	);
};

export default HeleneMannaDonationMessage;
